module.exports = __webpack_public_path__ + "images/help/icon-catagories-424d106280ef71468f924ea582e923ec.png";